import { IPwaContent } from '@adminPortal/_common/_interfaces/IPwaContent';
import { IPwaPreviewConfig } from '@adminPortal/_common/_interfaces/IPwaPreviewConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpEndpoints } from '@pwaPortal/core/enums/http-endpoints';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DataProviderService {
  constructor(private http: HttpClient) {}

  private buildUrl(path: HttpEndpoints | string, pathParams?: Record<string, string | number>): string {
    if (pathParams) {
      const paramKeys = Object.keys(pathParams);

      paramKeys.forEach((key: string) => {
        path = path?.replace(`:${key}`, pathParams[key].toString());
      });
    }

    // return `${this.apiUrl}${path}`;
    return `${path}`;
  }

  private buildHttpParams(queryParams: Record<string, string | number>): HttpParams {
    const paramKeys = Object.keys(queryParams);
    let params = new HttpParams();

    paramKeys.forEach((key: string) => {
      if (queryParams[key]) {
        params = params.append(key, queryParams[key]);
      }
    });

    return params;
  }

  // Public methods

  public getPwaLpConfig(): Observable<IPwaPreviewConfig> {
    const url = this.buildUrl(HttpEndpoints.LP_CONFIG);
    // console.log('2');
    return this.http.get<IPwaPreviewConfig>(url).pipe(map((res) => this.formatPwaFromBackend(res)));
  }

  public async getPwaLpConfigAsync(): Promise<IPwaPreviewConfig> {
    const url = this.buildUrl(HttpEndpoints.LP_CONFIG);
    // console.log('1')
    return firstValueFrom(this.http.get<IPwaPreviewConfig>(url)).then((res) => this.formatPwaFromBackend(res));
  }

  private formatPwaFromBackend(pwa: any): IPwaPreviewConfig {
    return {
      ...pwa,
      content: this.formatPwaContentFromBackend(pwa.content),
      offer: pwa.offer?.id || null,
    };
  }

  private formatPwaContentFromBackend(content: any): IPwaContent[] {
    // console.log(content);
    return Object.keys(content)
      .map((key) => ({
        ...content[key],
        updateDate: {
          ...content[key].updateDate,
          dateTime: content[key].updateDate.dateTime ? content[key].updateDate.dateTime.split('T')[0] : null,
        },
        languageCode: key,
        comments: content[key].comments?.length
          ? content[key].comments.map((el: any) => ({
              ...el,
              date: {
                ...el.date,
                dateTime: el.date?.dateTime ? el.date.dateTime.split('T')[0] : null,
              },
              answerDate: {
                ...el.answerDate,
                dateTime: el.answerDate?.dateTime ? el.answerDate.dateTime.split('T')[0] : null,
              },
            }))
          : [],
      }))
      .sort((a, b) => (a.isDefault ? -1 : 1));
  }
}
